export const ADD_CATEGORY ="ADD_CATEGORY";
export const CATEGORY_START ="CATEGORY_START";
export const CATEGORY_ERROR ="CATEGORY_ERROR";
export const GET_CATEGORIES ="GET_CATEGORIES";
export const GET_CATEGORY ="GET_CATEGORY";
export const DELETE_CATEGORY ="DELETE_CATEGORY";